var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8228 46.4791V30.7941H12.9779V23.5865H17.8228V20.4809C17.8228 12.4517 21.4418 8.73093 29.2947 8.73093C30.08 8.73093 31.1649 8.81348 32.1695 8.93338C32.922 9.0111 33.6685 9.13914 34.404 9.31666V15.8521C33.9788 15.8123 33.5522 15.7887 33.1252 15.7813C32.6468 15.7689 32.1683 15.763 31.6897 15.7636C30.3052 15.7636 29.2242 15.9523 28.4095 16.371C27.8619 16.6468 27.4015 17.0701 27.0798 17.5936C26.5746 18.4191 26.3474 19.5493 26.3474 21.0372V23.5865H34.0221L33.2662 27.72L32.7042 30.7941H26.3474V47C37.9838 45.5887 47 35.6451 47 23.5865C47 10.5608 36.4779 0 23.5 0C10.5221 0 0 10.5608 0 23.5865C0 34.6485 7.58658 43.9298 17.8228 46.4791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.0c998f92cacbc09305347471fcb9deee.svg";
export { ForwardRef as ReactComponent };